<div class="drawings-tab">
  @switch (view) {
    @case ('register') {
      <app-drawings-register [projectId]="projectId" [canConfigure]="canConfigure" [canPublish]="canPublish"
        (openSheet)="openSheet($event)" (openSet)="openSet($event)" (openMark)="openMark($event)"
        [listState]="listState" (listStateChange)="onListState($event)" />
    }
    @case ('set') {
      <app-drawing-set-review [projectId]="projectId" [setUuid]="setUuid" [canConfigure]="canConfigure" [canPublish]="canPublish"
        (back)="backToRegister()" (published)="backToRegister()" (reviewCarry)="openCarryForSet($event)" (previewDiff)="openPreviewDiff($event)" />
    }
    @case ('viewer') {
      <app-drawing-sheet-viewer [projectId]="projectId" [sheetUuid]="sheetUuid" [revisionUuid]="revisionUuid" [markUuid]="markUuid" [canConfigure]="canConfigure" [canPublish]="canPublish"
        [viewFilter]="viewFilter" (viewFilterChange)="onViewFilter($event)" [fullScreen]="fullScreen" (fullScreenChange)="onFullScreen($event)"
        (back)="backToRegister()" (openRevision)="openRevision($event)" (compare)="openCompare($event)" (openCarry)="openCarryForSheet($event)"
        (openSet)="openSet($event)" />
    }
    @case ('compare') {
      <!-- From set review's Preview changes (?set): back returns to the set review, not the draft page's sheet -->
      <app-drawing-compare [projectId]="projectId" [revisionUuid]="revisionUuid" [againstUuid]="compareUuid"
        [backLabelOverride]="setUuid ? 'Back to set review' : null" (back)="backFromCompare()" />
    }
    @case ('carry') {
      <app-drawing-carry-forward [projectId]="projectId" [setUuid]="carrySetUuid" [sheetUuid]="carrySheetUuid" [canPublish]="canPublish"
        (back)="backToRegister()" (openRevision)="openRevision($event)" />
    }
  }
</div>
